var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.397,
    height: 47.434,
    viewBox: "0 0 53.397 47.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#435877;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.074 -1.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.978,48.772a1.111,1.111,0,0,1-.777-.316L11.551,36.112a1.114,1.114,0,0,1-.091-1.493L37.843,1.757a1.112,1.112,0,0,1,1.931,1.021L26.042,47.987a1.112,1.112,0,0,1-.788.754A1.279,1.279,0,0,1,24.978,48.772ZM13.827,35.227l10.62,10.362L35.972,7.642Z",
    transform: "translate(13.648 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.129,30.516a1.11,1.11,0,0,1-.34-.053L.844,25.318a1.113,1.113,0,0,1-.1-2.083L51.922,1.429a1.112,1.112,0,0,1,1.112,1.907L17.805,30.287A1.113,1.113,0,0,1,17.129,30.516ZM4.36,24.117l12.553,4.049L44.653,6.945Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.278,46.356a1.172,1.172,0,0,1-.376-.065,1.112,1.112,0,0,1-.736-1.048V29.4a1.113,1.113,0,0,1,.436-.883L42.832,1.57a1.113,1.113,0,0,1,1.535,1.591L9.137,45.951A1.119,1.119,0,0,1,8.278,46.356Zm1.112-16.4v12.19L36.5,9.215Z",
    transform: "translate(8.688 0.002)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoun);
export default __webpack_public_path__ + "static/media/noun.2c748e21bb7eea67a8eb69536f6571ed.svg";
export { ForwardRef as ReactComponent };